import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import AreaReducer from './slices/area';
import BlogReducer from './slices/blog';
import CommissionsReducer from './slices/commission';
import ConclusionContractReducer from './slices/conclusionContract';
import CostCategoriesReducer from './slices/costCategory';
import CostsReducer from './slices/costs';
import crCategoryReducer from './slices/crCategory';
import CustomerCareReducer from './slices/customerCare';
import DailyWorkReducer from './slices/dailywork';
import DashboardReducer from './slices/dashboard';
import employeeReducer from './slices/employee';
import employeeCommissionReducer from './slices/employeeCommission';
import FileManagementReducer from './slices/fileManagements';
import FunctionTypeReducer from './slices/functionType';
import geographicBoundaries from './slices/geographicBoundaries';
import goodReducer from './slices/good';
import goodCategoryReducer from './slices/goodCategory';
import importWarehouseReducer from './slices/importWarehouse';
import internalOrgReducer from './slices/internalOrg';
import NotificationReducer from './slices/notification';
import OrderGiftReducer from './slices/orderGift';
import OrderSampleReducer from './slices/orderSample';
import partiesReducer from './slices/parties';
import PartyTypesReducer from './slices/partyTypes';
import PaymentAccountReducer from './slices/paymentAccounts';
import PaymentOrderReducer from './slices/paymentOrder';
import PermissionReducer from './slices/permission';
import roleReducer from './slices/role';
import SaleReceiptReducer from './slices/saleReceipt';
import ScreenReportReducer from './slices/screenReport';
import SupermarketsReducer from './slices/supermarkets';
import SupermarketStoreMappingReducer from './slices/supermarketStoreMapping';
import SystemSettingReducer from './slices/systemSetting';
import TagertMonthReducer from './slices/tagertMonth';
import TargetOKRReducer from './slices/targetOKR';
import userReducer from './slices/user';
import UtilReducer from './slices/utils';
import WarehouseExportReducer from './slices/warehouseExport';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  geographic: geographicBoundaries,
  internalOrg: internalOrgReducer,
  commissions: CommissionsReducer,
  employeeCommission: employeeCommissionReducer,
  employee: employeeReducer,
  parties: partiesReducer,
  good: goodReducer,
  goodCategory: goodCategoryReducer,
  user: userReducer,
  role: roleReducer,
  crCategory: crCategoryReducer,
  importWarehouse: importWarehouseReducer,
  functionType: FunctionTypeReducer,
  util: UtilReducer,
  dailywork: DailyWorkReducer,
  screenReport: ScreenReportReducer,
  warehouseExport: WarehouseExportReducer,
  saleReceipt: SaleReceiptReducer,
  customerCare: CustomerCareReducer,
  permission: PermissionReducer,
  partyTypes: PartyTypesReducer,
  tagertMonth: TagertMonthReducer,
  orderGift: OrderGiftReducer,
  paymentOrder: PaymentOrderReducer,
  notification: NotificationReducer,
  orderSample: OrderSampleReducer,
  fileManagement: FileManagementReducer,
  conclusionContract: ConclusionContractReducer,
  blog: BlogReducer,
  dashboard: DashboardReducer,
  supermarkets: SupermarketsReducer,
  supermarketStoreMapping: SupermarketStoreMappingReducer,
  costs: CostsReducer,
  costCategory: CostCategoriesReducer,
  area: AreaReducer,
  paymentAccounts: PaymentAccountReducer,
  systemSetting: SystemSettingReducer,
  targetOKR: TargetOKRReducer,
});

export { rootPersistConfig, rootReducer };

